import "@aws-amplify/ui-react/styles.css";
import {
  withAuthenticator,
  Button,
  Heading,
  Image,
  View,
  Text,
  TextField,
  SelectField,
  Card,
  Flex,
  Alert,
} from "@aws-amplify/ui-react";
import { FormEvent, useEffect, useState } from "react";
import { getUserData, postUserData } from "../api"
import { Navigate, useNavigate } from "react-router-dom";

//data
import { useContext } from 'react';
import { GlobalContext } from '../context/global';

import {
  AH2
} from "../components/text"
import {
  APadded
} from "../components/layout"
import { IUserData } from "../interfaces";
import { Loading } from "../components/loading";



// This page does the following
// We land here on /user-initial route if there is no userData

export const ViewUserData = (props : {isFirstRun? : boolean} = { isFirstRun : false}) => {
  const navigate = useNavigate();
  const [fetchingUser, setFetchingUser] = useState<boolean>(false);
  const {userData, setUserData} = useContext(GlobalContext);
  const [errorCount, setErrorCount] = useState<number>(0);
  const [done, setDone] = useState<boolean>(false);
  const [formUserData, setFormUserData] = useState<any>({
    weightKg: '',
    heightCm: '',
    yearOfBirth: '',
    sex: '',
  })


  const onFieldChange = (args : { name : string, value : string | number}) => {
    setFormUserData({
      ...formUserData,
      [args.name] : args.value,
    })
  }

  // Here we set a local copy of the data for the user to edit whenever we see it change
  useEffect(() => {
    if (userData.user) {
      setFormUserData({
        weightKg: userData.user.weightKg,
        heightCm:  userData.user.heightCm,
        yearOfBirth:  userData.user.yearOfBirth,
        sex:  userData.user.sex,
      })
    }
  }, [userData])

  useEffect(() => {


    if (!userData.haveFetched && errorCount <= 3 && !fetchingUser) {
        setFetchingUser(true);

        getUserData().then( (theData) => {
            //If there is no user, then we get undefined back from the endpoint
            setFetchingUser(false);


            if (!theData || !theData.ID) {
                //No user for this person, so we want to set them up.
                setUserData({ haveFetched: true}); // Set user to a blank user, indicating we have fetched but user doesn't exist
            }
     
            setUserData({ haveFetched: true, user: theData}); // Set user data in the provider to whatever we got back
            // also set our local copy for the user to edit if they want.
            setErrorCount(0);
        }).catch((e) => {
            console.log("Saw an error fetching user data");
            console.log(e)
            setFetchingUser(false);
            setErrorCount((x) => x+1);
        })
    }
  }, [userData, errorCount, fetchingUser]);

  if (errorCount > 3) {
    return <View><br/><Alert variation="error">There was an issue loading your data, check that you have internet and refresh the page.</Alert></View>
  }

  if (!userData.haveFetched) {
    // useEffect is loading up the userData
    return <Loading />
  }

  if (userData.haveFetched && userData.user?.heightCm && props.isFirstRun) {
    //We have already gathered the user data for this user, send them back home
    return <Navigate to="/" replace />
  }

  async function finishAndNavigateHome() {
    navigate("/");
  }

  //If we make it down here then
  // - We managed to load some user data
  // - But there is no heightCm etc. so we must fill out the form.
    
    async function updateUserData(click : FormEvent) {
        click.preventDefault();
        if (!click.target || !(click.target instanceof HTMLFormElement)) {
          console.warn("CreateEvent needs to be triggered from a HTML form submit");
          return;
        }
        const form = new FormData(click.target);
        if (typeof form.get("weightKg") !== 'string') return;
        if (isNaN(parseInt(form.get("weightKg") as string,10))) return;
        if (typeof form.get("heightCm") !== 'string') return;
        if (isNaN(parseInt(form.get("heightCm") as string,10))) return;
        if (typeof form.get("heightCm") !== 'string') return;
        if (isNaN(parseInt(form.get("heightCm") as string,10))) return;

        const data = {
          weightKg: parseInt(form.get("weightKg") as string,10),
          heightCm: parseInt(form.get("heightCm") as string,10),
          yearOfBirth: parseInt(form.get("yearOfBirth") as string,10),
          sex: form.get("sex") as "f" | "m" | "o", //todo validation
        };

        try {
            const userDataUpdateResponse = await postUserData(data);
            // now lets store the response data in some state.
            //props.onNutritionDataReceived(response.data);
            setUserData({ haveFetched: true, user: userDataUpdateResponse.data });
            setDone(true);
            
        } catch (e) {
            console.log("There was an error updating the user data");
            console.log(e);
        }
    }

    return <APadded>
            { props.isFirstRun ?
                <AH2>First, we just need to grab some details about you<br />so that we can tailor your nutrition packages.</AH2>
                : <AH2>Update your information</AH2>
            }
            { done ? <View>
                <AH2>Thanks, you're all set!</AH2>
                <Button onClick={() => {finishAndNavigateHome()}}>
                    Back to Home
                </Button>
                </View>
            : <View><View as="form" margin="3rem 0" onSubmit={updateUserData}>
            <Flex direction="Column" justifyContent="center">
            <TextField
                name="weightKg"
                placeholder="e.g. 75"
                label="Weight (kg)"
                variation="quiet"
                value={formUserData.weightKg}
                onChange={(evt) => onFieldChange({name: 'weightKg', value: evt.target.value})}
                required
            />
            <TextField
                name="heightCm"
                placeholder="e.g. 180"
                label="Height (cm)"
                value={formUserData.heightCm}
                onChange={(evt) => onFieldChange({name: 'heightCm', value: evt.target.value})}
                variation="quiet"
                required
            />
             <SelectField
                label="Sex"
                name="sex"
                value={formUserData.sex}
                onChange={(evt) => onFieldChange({name: 'sex', value: evt.target.value})}
              >
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other" >Other</option>
              </SelectField>
            <TextField
                name="yearOfBirth"
                placeholder="e.g. 1990"
                label="Year of birth"
                value={formUserData.yearOfBirth}
                onChange={(evt) => onFieldChange({name: 'yearOfBirth', value: evt.target.value})}
                //labelHidden
                variation="quiet"
                required
            />
            <Button type="submit">
                Save
            </Button>
            </Flex>
        </View>
        <View margin="3rem 0">
        {/* {notes.map((note) => (
          <Flex
            key={note.id || note.name}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Text as="strong" fontWeight={700}>
              {note.name}
            </Text>
            <Text as="span">{note.description}</Text>
            <Button variation="link" onClick={() => alert("Not implemented")}>
              Delete note
            </Button>
          </Flex>
        ))} */}
        </View>
      </View>
        }
      </APadded>
}